<template>
  <header class="landing-title">
    <h2 class="title">
      <slot name="title"></slot>
    </h2>
    <p class="subtitle">
      <slot name="subtitle"></slot>
    </p>
  </header>
</template>

<style lang="scss" scoped>
.landing-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;

  @include media-breakpoint-down(md) {
    margin-bottom: 16px;
  }

  .title {
    width: 650px;
    margin-bottom: 20px;
    text-align: center;
    font-weight: 600;
    font-size: stretch-size(375, 1920, 32, 52);
    line-height: stretch-size(375, 1920, 39, 52);

    :slotted(span) {
      color: var(--app-color-primary);
    }

    @include media-breakpoint-down(md) {
      width: 100%;
      margin-bottom: 16px;
    }
  }

  .subtitle {
    width: 680px;
    text-align: center;
    margin-bottom: 20px;
    font-size: stretch-size(375, 1920, 17, 24);
    line-height: stretch-size(375, 1920, 24, 32);

    @include media-breakpoint-down(xl) {
      width: 570px;
    }

    @include media-breakpoint-down(md) {
      width: 100%;
      margin-bottom: 16px;
    }
  }
}
</style>
